import SignupModal from './SignupModal.vue'

export default  SignupModal



// WEBPACK FOOTER //
// ./apps/comps/SignupModal/index.js